import { transition } from '@helpers/animate';
import { imageCoverContainer } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { baseGrid } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { contentStyles, h1 } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Global/SectionWrapper/SectionWrapper.styles';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  position: relative;

  ${SectionWrapperStyles.SiteWide} {
    @media ${until(Device.Tablet)} {
      padding-left: 0;
      padding-right: 0;
    }
  }
`;
const Inner = styled.div `
  border-left: 10px solid var(--themeColor);

  @media ${from(Device.DesktopSmall)} {
    ${baseGrid};
    height: 400px;
    border: none;
  }
`;
const ContentArea = styled.div `
  background-color: ${brand.grey.grey91};
  padding: 20px ${fluid(25, 40)};
  min-height: 280px;

  @media ${from(Device.Tablet)} {
    position: relative;
    z-index: 1;
    grid-column: span 4;
    border-left: ${fluid(10, 20)} solid var(--themeColor);
  }
`;
const BannerTitle = styled.h1 `
  ${h1};
  margin-bottom: 20px;
`;
const Content = styled.div `
  ${contentStyles};
`;
const CtaArea = styled.div `
  padding-top: 25px;
`;
const MediaArea = styled.div `
  position: relative;
  height: 200px;
  width: 100%;

  @media ${from(Device.Tablet)} {
    border-left: clamp(0.56rem, 0.25rem + 0.97vw, 1.11rem) solid var(--themeColor);
  }

  @media ${from(Device.DesktopSmall)} {
    position: absolute;
    width: 68vw;
    height: 400px;
    right: 0;
  }
`;
const CitationBtn = styled.button `
  ${transition('background-color')};
  position: absolute;
  right: 0;
  bottom: 0;
  border: none;
  border-radius: 0;
  background-color: transparent;
  height: 40px;
  padding: 0 40px;

  @media ${until(Device.Tablet)} {
    width: 100%;
    height: 35px;
  }

  &[data-citation-open='true'] {
    background-color: ${rgba(brand.white, 0.9)};
  }
`;
const CitationIcon = styled.div `
  ${transition('background-color')};
  ${fonts.agBook.bold};
  color: ${brand.white};
  width: 30px;
  height: 30px;
  background-color: ${rgba(brand.grey.grey41, 0.9)};
  border-radius: 100%;
  font-size: 22px;
  line-height: 30px;
  margin-right: 40px;
  margin-top: -20px;

  @media ${until(Device.Tablet)} {
    position: absolute;
    top: -35px;
    right: 20px;
    margin-right: 0;
    margin-top: 0;
  }

  ${CitationBtn}:hover &,
  ${CitationBtn}:focus {
    background-color: ${brand.orange};
  }

  [data-citation-open='true'] & {
    @media ${from(Device.Tablet)} {
      display: none;
    }
  }
`;
const CitationContent = styled.span `
  ${fonts.agBook.light};
  font-style: italic;
  font-size: 12px;
  line-height: 14px;
  display: none;

  [data-citation-open='true'] & {
    display: block;
  }
`;
const PromoMedia = styled.div `
  ${imageCoverContainer()};
`;
const PromoImage = styled.img `
  ${imageCoverContainer()};
`;
export const InnerPageBannerStyles = {
    BannerTitle,
    CitationBtn,
    CitationContent,
    CitationIcon,
    Container,
    Content,
    ContentArea,
    CtaArea,
    Inner,
    MediaArea,
    PromoImage,
    PromoMedia,
};
